import type { ApiTrackingLabels, KnownTrackingLabels, TrackingLabels } from '@shared/tracking/TrackingLabels';
import type { IntentResult, SearchContext } from '@shared/types/types';
import type { OnEx } from '@tilelist/domain/experiments/OnEx';
import { extractComparisonId } from '@tilelist/domain/feature-visibility/ComparisonService';

type ComparisonBaseTrackingLabels = Pick<KnownTrackingLabels, 'san_Comparison'>;

type HeaderTypeBaseTrackingLabels = Pick<KnownTrackingLabels, 'san_HeaderType'>;

type ListFeedbackToolBaseTrackingLabels = Pick<KnownTrackingLabels, 'wk.san_ListFeedbackTool'>;

type PaginationBaseTrackingLabels = Pick<
    KnownTrackingLabels,
    'wk.san_ListOrder' | 'wk.san_PageNumber' | 'wk.san_CountPages'
>;

type AdditionalBaseTrackingLabels = Pick<KnownTrackingLabels, 'san_HeaderType' | 'wk.san_ListFeedbackTool'>;

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function mergeTracking(intents: IntentResult[]): ApiTrackingLabels {
    return intents.reduce<ApiTrackingLabels>((merged, intent) => {
        const tracking = intent.meta?.tracking;
        if (!tracking) return merged;

        for (const [key, values] of Object.entries(tracking)) {
            (merged[key] ??= []).push(...values);
        }

        return merged;
    }, {});
}

export function comparisonTrackingLabels(searchContext: SearchContext, onex?: OnEx): ComparisonBaseTrackingLabels {
    const { comparisonId } = extractComparisonId(searchContext, undefined, onex);

    if (comparisonId) {
        return { san_Comparison: true };
    }

    return {};
}

/**
 *
 *
 *
 *
 *
 *
 */
export function getHeaderTypeTracking(isMobile: boolean): HeaderTypeBaseTrackingLabels {
    return isMobile ? { san_HeaderType: 'mobile' } : {};
}

/**
 *
 *
 *
 *
 *
 *
 *
 */
export function getListFeedbackToolTracking(): ListFeedbackToolBaseTrackingLabels {
    return { 'wk.san_ListFeedbackTool': 'feedback_ltr' };
}

/**
 *
 *
 */
export function paginationTrackingLabels(
    sortOrder: string | undefined,
    currentPage: number,
    lastPage: number,
): PaginationBaseTrackingLabels {
    return {
        ...(sortOrder ? { 'wk.san_ListOrder': sortOrder } : {}),
        'wk.san_PageNumber': currentPage,
        'wk.san_CountPages': lastPage,
    };
}

/**
 *
 *
 */
export function additionalBaseTracking(isMobile: boolean): AdditionalBaseTrackingLabels {
    return {
        ...getHeaderTypeTracking(isMobile),
        ...getListFeedbackToolTracking(),
    };
}

export function composeBaseTrackingLabels(
    intents: IntentResult[],
    isMobile: boolean,
    searchContext: SearchContext,
    sortOrder: string | undefined,
    currentPage: number,
    lastPage: number,
    onex?: OnEx,
): TrackingLabels {
    return {
        ...mergeTracking(intents),
        ...additionalBaseTracking(isMobile),
        ...comparisonTrackingLabels(searchContext, onex),
        ...paginationTrackingLabels(sortOrder, currentPage, lastPage),
    };
}
